import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import { useJsonApi } from "@/modules/api/hooks/useJsonApi";
import { useMutation } from "@/modules/api/hooks/useMutation";
import { apiErrorValidate } from "@/modules/api/utils/apiErrorValidate";
import { resetPasswordMutation } from "@/modules/auth/api/mutations/resetPassword/resetPasswordMutation";
import { anonymousRouting } from "@/modules/router/routings/anonymousRouting";

const translationNamespace = "apiMessages/useResetPasswordMutation";

export const useResetPasswordMutation = () => {
  const history = useHistory();
  const jsonApi = useJsonApi();
  const { t } = useTranslation(translationNamespace);

  return useMutation([resetPasswordMutation.name], {
    mutationFn: resetPasswordMutation(jsonApi),
    onSuccess: () => {
      history.replace(anonymousRouting.buildUrl("resetPasswordSuccess"));
    },
    onError: (error) => {
      apiErrorValidate(error, {
        403: {
          FORBIDDEN: t(
            "You are not allowed to reset the password. Please try again or contact the administrator"
          ),
        },
      });
    },
    retry: false,
  });
};
